<!-- Filter Datatables -->
<section id="ngx-datatable-filter">
    <div class="row">
      <div class="col-12"></div>
      <div class="col-12">
        <div class="card">
          <div class="card-content">
            <div class="card-body">
              <!-- ngx-datatable-filter -->
              <fieldset class="form-group">
                <div class="row">
                  <div class="col-12 col-sm-12 col-md-6 col-lg-6 mb-1">
                    <label
                      >Show
                      <select
                        name="users-list-select"
                        class="form-control form-control-sm d-inline-block width-100 p-right-25 pl-4 mx-1"
                        (click)="updateLimit($event)"
                      >
                        <option value="10">10</option>
                        <option value="25">25</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                      </select>
                      entries</label
                    >
                  </div>
                  <div class="col-12 col-sm-12 col-md-6 col-lg-6 mb-1">
                    <div class="row-flex">
                      <div class="col-flex-2 mb-1">
                        <label for="ngx-filter-ref"
                          >Search:
                          <input
                            id="ngx-filter-ref"
                            class="form-control form-control-sm d-inline-block width-200 ml-1"
                            type="text"
                          />
                        </label>
                      </div>
                      <!-- <div class="faq-wrapper">
                        <div class="faq-search">
                          <form class="d-flex justify-content-center ng-untouched ng-pristine ng-valid">
                            <div class="faq-search-input form-group position-relative w-100 mb-0">
                              <input type="text" (keyup)="getTagsFilter($event)" class="form-control form-control-lg shadow p-3" id="searchbar"
                                placeholder="Search">
                              <button class="btn btn-primary position-absolute" type="button">
                                <span class="d-none d-sm-block">Search</span>
                                <i class="ft-search d-block d-sm-none"></i>
                              </button>
                            </div>
                          </form>
                          </div>
                      </div> -->
                      <div class="col-flex-2 mb-1">
                        <button
                          type="reset"
                          class="btn btn-primary btn-block users-list-clear glow mb-0"
                          routerLink="/transaction/add-transaction"
                        >
                          Add
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </fieldset>
              <ngx-datatable
                class="bootstrap core-bootstrap"
                [columnMode]="ColumnMode.force"
                [headerHeight]="50"
                [footerHeight]="50"
                rowHeight="auto"
                [limit]="limitRef"
                [rows]="rows"
                [scrollbarH]="true"
                [columns]="columns"
                [externalPaging]="true"
                [count]="page.totalPages"
                [offset]="page.offset"
                (page)="pageChangeData($event)"
              >
                <ngx-datatable-column
                  name="Name"
                  prop="name"
                  [width]="80"
                >
                  <ng-template
                    let-row="row"
                    let-name="value"
                    ngx-datatable-cell-template
                  >
                    <div class="d-flex align-items-center">
                      <img
                        class="rounded-circle mr-1"
                        *ngIf="row.image"
                        [src]="imageUrl + row.image"
                        height="32"
                        width="32"
                      />
                      <div *ngIf="!row.image" class="avatar mr-1 bg-primary">
                        <div class="avatar-content">{{ row?.user?.name | shortName }}</div>
                      </div>  
  
                      <!-- <div class="cell-line-height">
                        <a
                          class="line-height-1 mb-0"
                          [routerLink]="['/tags/tag-view', row._id]"
                          (click)="editTag(row._id)"
                          >{{ row.tagName }}</a
                        >
                      </div> -->
                      <div class="cell-line-height cursor-pointer" [routerLink]="['/transaction/transaction-history']"
                      (click)="editTransaction(row.student._id)">
                        <p class="font-medium-1 line-height-1 mb-0">
                          {{ row?.user?.name }}
                        </p>
                        <!-- <span class="text-muted font-small-2">
                          Nuclear Power Engineer</span
                        > -->
                      </div>
                    </div>
                  </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column
                name="Net Fee"
                prop="net_amount"
                [width]="20">
                <ng-template
                  let-row="row"
                  let-name="value"
                  ngx-datatable-cell-template>
                  <span class="badge bg-light-success users-view-status"> {{row?.transactions[0]?.net_amount | currency:'INR':'symbol'}} </span>
                </ng-template>
              </ngx-datatable-column>
                <ngx-datatable-column
                  name="Total Paid"
                  prop="paid_amount"
                  [width]="20">
                  <ng-template
                    let-row="row"
                    let-name="value"
                    ngx-datatable-cell-template>
                    <span class="badge bg-light-success users-view-status"> {{row?.transactions[0]?.paid_amount | currency:'INR':'symbol'}} </span>
                  </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column
                name="Paid Fee"
                prop="paid_amount"
                [width]="20">
                <ng-template
                  let-row="row"
                  let-name="value"
                  ngx-datatable-cell-template>
                  <span class="badge bg-light-danger users-view-status"> {{row?.transactions[0]?.paid_amount | currency:'INR':'symbol'}} </span>
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column
              name="Pending Fee"
              prop="pendingAmount"
              [width]="20">
              <ng-template
                let-row="row"
                let-name="value"
                ngx-datatable-cell-template>
                <span class="badge bg-light-danger users-view-status"> {{row?.transactions[0]?.pendingAmount | currency:'INR':'symbol'}} </span>
              </ng-template>
            </ngx-datatable-column>
                <ngx-datatable-column
                  name="Payment Status"
                  prop="payment_status"
                  [width]="20" 
                >
                <ng-template
                let-row="row"
                let-name="value"
                ngx-datatable-cell-template
              >
              <span class="badge bg-light-primary">
                {{row?.transactions[0]?.payment_status | titlecase}}
              </span>
              </ng-template>
                </ngx-datatable-column>
                <!-- <ngx-datatable-column
                name="Transaction Date"
                prop="createdOn"
                [width]="30"
              >
              <ng-template
              let-row="row"
              let-name="value"
              ngx-datatable-cell-template
            >
            {{row?.created_at | date: "mediumDate"}}
            </ng-template>
              </ngx-datatable-column> -->
                <ngx-datatable-column name="Actions" [width]="50">
                  <ng-template let-row="row" ngx-datatable-cell-template>
                    <!-- <i
                      class="ft-edit text-primary cursor-pointer mr-2"
                      [routerLink]="['/transaction/edit-transaction', row._id]"
                      (click)="editTransaction(row._id)"
                    ></i> -->
                    <i
                      class="ft-trash-2 cursor-pointer danger"
                      (click)="ConfirmColor(row._id)"
                    ></i>
                  </ng-template>
                </ngx-datatable-column>
              </ngx-datatable>
              <!-- ngx-datatable-filter -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!--/ Filter Datatables -->
  